import URL from 'url'
import codifyUrlStateParams from './codifyURLStateParams'
import configHandler from '../configHandler';

function redirectToLogoutSTS(config, state) {
  const authUri = URL.parse(config.EXTERNAL_OAUTH_URL),
    clientId = config.EXTERNAL_OAUTH_KEY,
    redirectUri = encodeURIComponent(config.TAXONLINE_SME_DASHBOARD_OAUTH_REDIRECT_URI_ARL);

  authUri.pathname = 'oauth2/account/logoff';
  authUri.search =`client_id=${clientId}&redirect_uri=${redirectUri}&state=${codifyUrlStateParams.encode(state)}`;

  window.location.assign(`${URL.format(authUri)}`);
}

export default state => {
  const config = configHandler();
  const request = URL.parse(`${config.TAXONLINE_PUBLIC_API_URL}/logout`);

  return fetch(request.format(), { credentials: 'include' })
    .then(() => redirectToLogoutSTS(config, state))
    .catch(error => {
      console.error('Error occurred while calling the logout endpoint', error);
      redirectToLogoutSTS(config, state)
    });
}



// WEBPACK FOOTER //
// ./src/app/helpers/logout.js